import React, { Component } from 'react';
import { formatCurrency } from '@C/TableGrid';
import { Banknote } from 'lucide-react';

export class Purchases extends Component {
  constructor() {
    super();
  }

  render() {
    const summary = this.props.summary;
    return (
      <>
        <section className="widget dsr-table">
          <header>
            <Banknote color="#31af36" />
            <h3> Purchase Summary</h3>
          </header>
          <main className="content-wrapper">
            <table className="dsr" data-name="Purchase Summary">
              <thead>
                <tr data-header={true}>
                  <th>#</th>
                  <th>Invoice #</th>
                  <th>Product</th>
                  <th>Quantity</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                {summary.map((val, key) => {
                  return (
                    <tr key={key}>
                      <td>{key + 1}</td>
                      <td>{val.invoice_number}</td>
                      <td>{val.product}</td>
                      <td>{val.total_quantity}</td>
                      <td> {formatCurrency(val.total_amount || 0)}</td>
                    </tr>
                  );
                })}
                <tr className="summary-row">
                  <td colSpan="4">Total </td>
                  <td>
                    {formatCurrency(
                      summary.reduce(
                        (a, b) => a + (b['total_amount'] || 0),
                        0,
                      ) || 0,
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </main>
        </section>
      </>
    );
  }
}
